import React from 'react';
import { Link } from 'react-router-dom';

import { Bloc } from '@mairistem/administres-utils';
import { Icon } from '@mairistem/composants';

import { useEntiteStore } from '@/zustand';
import ActeListeContainer from '@/components/Acte/Liste/ActeListeContainer';

interface BlocListeProps {
  style?: React.CSSProperties;
}

const BlocListe = (props: BlocListeProps) => {
  const { style } = props;
  const blocked = useEntiteStore((state) => state.blocked);

  if (blocked) {
    return null;
  }

  return (
    <Bloc icon="search" header="Rechercher un événement" style={style}>
      <ActeListeContainer dashboard />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '1.5em',
        }}
      >
        <Link
          to="/pacs"
          style={{
            display: 'block',
            color: 'inherit',
            cursor: 'pointer',
            textDecoration: 'none',
          }}
        >
          Voir tout
          <Icon
            name="arrow right"
            style={{
              border: '1px solid grey',
              padding: '0.7em',
              borderRadius: '4px',
              display: 'inline',
              marginLeft: '15px',
            }}
          />
        </Link>
      </div>
    </Bloc>
  );
};

export default BlocListe;
